import { configureStore } from '@reduxjs/toolkit'
import settingsReducer from '../shared-components/settings-panel/store/settingsSlice';

export const store = configureStore({
    reducer: {
        settings : settingsReducer
    },
})